var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vs-chip',{staticClass:"ag-grid-cell-chip success",attrs:{"color":_vm.status}},[(_vm.lastPing)?_c('vx-tooltip',{attrs:{"text":_vm.$t('status.lastPing') + ' ' + _vm.lastPing}},[_c('span',[_vm._v(_vm._s(_vm.verifyIsOnline(_vm.params.value)))])]):_c('span',[_vm._v(_vm._s(_vm.verifyIsOnline(_vm.params.value)))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }